import React from 'react'
import SectionBase from './SectionBase'

export default () => (
  <SectionBase
    titleText="Enable the Book Now button on your PGA Coach Profile to allow potential students to book a session with you right from PGA.com!"
    gtmLearnObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'enable-book-now',
      onboardingAction: 'click-learn-more',
    }}
    learnMoreLink="https://support.pga.com/en/articles/5725788-book-now-button"
    gtmDoActionObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'enable-book-now',
      onboardingAction: 'click-get-started',
    }}
    doActionLink="/pga-coach/settings"
    doActionText="Enable Book Now"
  />
)
